import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashIfEmpty } from './dashIfEmpty.pipe';

@NgModule({
  declarations: [DashIfEmpty],
  imports: [CommonModule],
  exports: [DashIfEmpty],
})
export class PipesModule {}
